module.exports = __webpack_public_path__ + "img/placeholder_desktop.4ae6af9e.png";